export default __webpack_public_path__ + "static/media/img_code_02.ac496c67.png";